export default {
    setSelectedReceiptLog(state, receiptLog) {
        state.selectedReceiptLog = receiptLog;
    },
};
